import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import LeftNav from './LeftNav';
import ProfileDetails from './EditProfile/ProfileDetails';
import EditAddressForm from './EditProfile/EditAddressForm';
import EditPaymentForm from './EditProfile/EditPaymentForm';
import moment from 'moment';
import MetaTags from 'react-meta-tags';
import Loading from '../../ui/Loading';
import MetaLoader from '../../ui/MetaLoader';

class EditProfile extends Component {
  constructor(props) {
    super(props);
    const {
      match: { params }
    } = props;

    const { page } = params || {};

    this.state = {
      activeEdit: page || '',
      activeAddress: 0,
      activePayment: 0,
      searchAddress: true,
      searchValue: '',
      address1: ''
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getLookups();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentDidUpdate(prevProps) {
    const { match: { params } } = this.props;
    const { match: { params: prevParams } } = prevProps;

    const { page } = params || {};
    const { page: prevPage } = prevParams || {};

    if (page === prevPage) return;

    this.setState({ activeEdit: page || '' });
  }
  render() {
    const {
      postAddress,
      putAddress,
      putAddressError,
      postAddressError,
      postCard,
      postCardError,
      putCard,
      putCardError,
      putBirthday,
      putBirthdayError,
      putPassword,
      putPasswordError,
      user,
      lookups,
      history,
      deleteAddress,
      deleteCard,
      postNameAndEmail,
      postSecondaryContact,
      patchSecondaryContact,
      deleteAddressError,
      deleteCardError,
      clearDeleteAddress,
      clearDeleteCard,
      loading,
      clearPutAddress,
      getAddressSuggestionsResult,
      getAddressSuggestions
    } = this.props;

    const {
      userId,
      AddressBook,
      CreditCards,
      IsActiveClubMember
    } = user || {};

    const {
      activeEdit,
      activeAddress,
      activePayment,
      searchAddress,
      searchValue
    } = this.state;


    const toggle = setting => {
      if (setting === activeEdit) return history.push('/account/edit-profile');
      history.push(`/account/edit-profile/${setting}`);
    };

    // set the active edit address, used on the edit link in edit profile Address Book
    const setActiveAddressId = editingAddressId => {
      this.setState({ activeAddress: editingAddressId });
      toggle('edit-address');
    };

    const getActiveAddress = editingAddressId => {
      const {
        FirstName: name_first,
        LastName: name_last,
        City,
        Address1,
        Address2,
        Label,
        Company,
        Zip,
        Phone,
        StateID,
        DOB,
        IsClubAddress: isClubAddress,
        IsDefaultMailing: isDefaultMailing,
        IsDefaultShipping: isDefaultShipping
      } = (AddressBook || [])
        .find(x => x.AddressBookID === editingAddressId) || {};

      //convert dob to seperate fields
      const dob = moment(DOB);
      const dobYear = dob.year();
      const dobDay = dob.date();
      const dobMonth = dob.month();

      return {
        name_first,
        name_last,
        City,
        Address1,
        Address2,
        Label,
        Company,
        Zip,
        Phone,
        StateID,
        dobDay,
        dobMonth,
        dobYear,
        isDefaultShipping,
        isDefaultMailing,
        isClubAddress
      };
    };

    // set the active edit payment, used on the edit link in edit profile Payment
    const setActivePaymentId = editingPaymentId => {
      this.setState({ activePayment: editingPaymentId });
      toggle('edit-payment');
    };

    const { secondaryContact } = user || {}
    const { SecondaryContactId } = secondaryContact || {}

    const getActivePayment = editingPaymentId => {
      const {
        LastFour,
        ExpirationMonth,
        ExpirationYear,
        CardTypeId,
        AddressBookId,
        CardId,
        IsDefault
      } = (CreditCards || []).find(x => x.CardId === editingPaymentId) || {};

      const {
        FirstName: name_first,
        LastName: name_last
      } = (AddressBook || []).find(x => x.AddressBookID === AddressBookId) || {
      };

      return {
        name_first,
        name_last,
        LastFour,
        ExpirationMonth,
        ExpirationYear,
        AddressBookId,
        cardId: CardId,
        IsDefault
      };
    };

    const scrollToTop = () => window.scrollTo(0, 0);

    // handler functions
    const handlePostAddress = values =>
      postAddress(
        { payload: { ...values, IsActiveClubMember }, id: userId },
        'edit-address-form',
        null,
        () => toggle('address-book')
      );
    const handlePutAddress = values =>
      putAddress(
        { payload: { ...values, IsActiveClubMember }, id: userId, addressId: activeAddress },
        'edit-address-form'
      );
    const handlePostCard = values =>
      postCard({ payload: { ...values, IsActiveClubMember }, id: userId }, 'edit-payment-form', null, () =>
        toggle('payment'));

    const handlePutCard = values =>
      putCard({ payload: values, id: userId }, 'edit-payment-form', null, () =>
        toggle('payment'));

    const handlePutBirthday = values =>
      putBirthday(
        { payload: values, id: userId },
        'edit-birthday-form',
        null,
        () => toggle('birthday')
      );
    const handlePutPassword = values =>
      putPassword(
        { payload: values, id: userId },
        'edit-password-form',
        null,
        () => toggle('password')
      );

    const handlePostNameAndEmail = values =>
      postNameAndEmail({ payload: { ...values, brandingId: 2 } }, 'name-and-email-form', null, () =>
        toggle('name-and-email'));

    const handlePostPatchSecondaryContact = values => {
      if (!SecondaryContactId) {
        postSecondaryContact({ payload: values, }, 'secondary-contact-form', null, () =>
          toggle('secondary-contact'))
      }

      patchSecondaryContact({ payload: { ...values, SecondaryContactId } }, 'secondary-contact-form', null, () =>
        toggle('secondary-contact'))
    };

    const addressFormData = getActiveAddress(activeAddress);
    const paymentFormData = getActivePayment(activePayment);


    const handleGetAddressSuggestions = async (value) => {
      this.setState({ searchValue: value });
      if ((value || []).length > 2) {
        await getAddressSuggestions({ searchText: value });
      }
    };
    const handleSelect = ({ address1, searchAddress }) => {
      this.setState({ address1: address1, searchAddress: searchAddress });
    }
    return (
      <div id="content" className="site-content">
        <MetaLoader title="Edit Profile | Account | Twomey" />
        <MetaTags>
          <title>Edit Profile | Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Edit Profile | Account | Twomey" />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/edit-profile"
          />
        </MetaTags>
        <div id="primary" className="content-area">

          <main id="main" className="site-main account-page nohero">
            <div className="container">
              <div className="row">

                <LeftNav />

                {loading && <Loading fullPage scrollToTop />}
                {!loading &&
                  activeEdit !== 'add-address' &&
                  activeEdit !== 'add-payment' &&
                  <ProfileDetails
                    toggle={toggle}
                    active={activeEdit}
                    user={user}
                    setActiveAddressId={setActiveAddressId}
                    setActivePaymentId={setActivePaymentId}
                    handlePutPassword={handlePutPassword}
                    errorPassword={putPasswordError}
                    handlePutBirthday={handlePutBirthday}
                    errorBirthday={putBirthdayError}
                    deleteAddress={deleteAddress}
                    deleteCard={deleteCard}
                    handlePostNameAndEmail={handlePostNameAndEmail}
                    handlePostPatchSecondaryContact={handlePostPatchSecondaryContact}
                    deleteAddressError={deleteAddressError}
                    deleteCardError={deleteCardError}
                    clearDeleteAddress={clearDeleteAddress}
                    clearDeleteCard={clearDeleteCard}
                  />}

                {!loading &&
                  activeEdit === 'add-address' &&
                  <EditAddressForm
                    onSubmit={handlePostAddress}
                    errorSubmit={postAddressError}
                    initialValues={{}}
                    editType={'Add'}
                    toggle={toggle}
                    lookups={lookups}
                    clearPutAddress={clearPutAddress}
                    handleSelect={handleSelect}
                    searchValue={searchValue}
                    searchAddress={searchAddress}
                    getAddressSuggestionsResult={getAddressSuggestionsResult}
                    handleGetAddressSuggestions={handleGetAddressSuggestions}
                  />}

                {!loading &&
                  activeEdit === 'edit-address' &&
                  <EditAddressForm
                    onSubmit={handlePutAddress}
                    errorSubmit={putAddressError}
                    initialValues={addressFormData}
                    editType={'Edit'}
                    toggle={toggle}
                    lookups={lookups}
                    clearPutAddress={clearPutAddress}
                    handleSelect={handleSelect}
                    searchValue={searchValue}
                    searchAddress={searchAddress}
                    getAddressSuggestionsResult={getAddressSuggestionsResult}
                    handleGetAddressSuggestions={handleGetAddressSuggestions}
                  />}

                {!loading &&
                  activeEdit === 'add-payment' &&
                  <EditPaymentForm
                    onSubmit={handlePostCard}
                    errorSubmit={postCardError}
                    initialValues={{ IsDefault: true }}
                    editType="Add"
                    toggle={toggle}
                    lookups={lookups}
                    AddressBook={AddressBook}
                  />}

                {!loading &&
                  activeEdit === 'edit-payment' &&
                  <EditPaymentForm
                    onSubmit={handlePutCard}
                    errorSubmit={putCardError}
                    initialValues={paymentFormData}
                    editType="Edit"
                    toggle={toggle}
                    lookups={lookups}
                    AddressBook={AddressBook}
                  />}
              </div>
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    error: postAddressError
  } = state.postAddress.toJS();

  const {
    error: putAddressError,
    inProgress: editAddressInProgress
  } = state.putAddress.toJS();

  const {
    error: postCardError
  } = state.postCard.toJS();

  const {
    error: putCardError
  } = state.putCard.toJS();

  const {
    error: putPasswordError
  } = state.putPassword.toJS();

  const {
    error: putBirthdayError
  } = state.putBirthday.toJS();

  const {
    error: deleteAddressError
  } = state.deleteAddress.toJS();

  const {
    error: deleteCardError
  } = state.deleteCard.toJS();

  const {
    result: user,
    inProgress
  } = state.postLogin.toJS();
  const {
    result: getAddressSuggestionsResult
  } = state.getAddressSuggestions.toJS();
  const {
    // error,
    inProgress: lookupsInProgress,
    result: lookups
  } = state.getLookups.toJS();

  return {
    lookups,
    deleteAddressError,
    deleteCardError,
    postAddressError,
    putAddressError,
    postCardError,
    putCardError,
    putBirthdayError,
    putPasswordError,
    user,
    inProgress: editAddressInProgress || lookupsInProgress,
    loading: inProgress,
    getAddressSuggestionsResult
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postAddress: fetchDux.postAddress.createAction,
      putAddress: fetchDux.putAddress.createAction,
      postCard: fetchDux.postCard.createAction,
      putCard: fetchDux.putCard.createAction,
      putBirthday: fetchDux.putBirthday.createAction,
      putPassword: fetchDux.putPassword.createAction,
      getLookups: fetchDux.getLookups.createAction,
      deleteAddress: fetchDux.deleteAddress.createAction,
      deleteCard: fetchDux.deleteCard.createAction,
      clearDeleteAddress: fetchDux.deleteAddress.clearAction,
      clearDeleteCard: fetchDux.deleteCard.clearAction,
      postNameAndEmail: fetchDux.postNameAndEmail.createAction,
      postSecondaryContact: fetchDux.postSecondaryContact.createAction,
      patchSecondaryContact: fetchDux.patchSecondaryContact.createAction,
      clearPutAddress: fetchDux.putAddress.clearAction,
      getAddressSuggestions: fetchDux.getAddressSuggestions.createAction,
      clearGetAddressSuggestions: fetchDux.getAddressSuggestions.clearAction,
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(EditProfile);
